import React from 'react';
import './index.scss';
const TableCountryIcon = (porps: any) => {
  const { cvm, id, icon } = porps;
  //报错，暂时注释
  return (
    <div className="dbi-marketprofile-table-country">
      {id ? <span className="dbi-marketprofile-table-rank">{id}</span> : ''}
      <div className="dbi-marketprofile-table-img">
        <img src={icon} alt="" />
      </div>
      {/* <span
        className={`dbi-marketprofile-table-text 
        ${item.marketNameEn != 'global' &&
            item.marketNameEn != 'global_wo_china'
            ? 'hover-style'
            : ''
          }`
        }
      > */}
      <span className={`dbi-marketprofile-table-text`} >
        {cvm}
      </span>
    </div>
  );
};

export default TableCountryIcon;
